import { appendUTMData } from "./utm";

const CRM_ACTION = "crm_form";

const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const isValidPhone = (phone) =>
  /^\d{10}$/.test(phone.replace(/\s+/g, ""));

function setFieldError(element, message) {
  if (!element) return;

  element.textContent = message;
  element.classList.toggle("visible", Boolean(message));
}

function showFormMessage(element, text, success) {
  if (!element) {
    return;
  }

  element.textContent = text;
  element.className = `form-message ${success ? "success" : "error"}`;
  element.style.display = "block";

  setTimeout(() => {
    element.style.display = "none";
    element.textContent = "";
    element.className = "form-message";
  }, 4000);
}
async function submitCRMForm(form) {
  const formData = new FormData(form);

  formData.set("action", CRM_ACTION);
  appendUTMData(formData);

  // Visualizar payload
  const payload = Object.fromEntries(formData.entries());

  console.group(`CRM Payload - ${payload.formulario}`);
  console.table(payload);
  console.log("JSON:", JSON.stringify(payload, null, 2));
  console.groupEnd();

  const response = await fetch(cltvo_js_vars.ajax_url, {
    method: "POST",
    body: formData,
  });

  const data = await response.json();

  if (!response.ok || data.success === false || data.error) {
    throw new Error(
      data.message || data.data?.message || `Error HTTP ${response.status}`
    );
  }

  return {
    success: data.success ?? true,
    message: data.message || data.data?.message || "Formulario enviado correctamente.",
  };
}

document.addEventListener("DOMContentLoaded", () => {
  // ---------------------------------
  // Formulario de muestra
  // ---------------------------------

  const form = document.getElementById("muestra-form");

  if (!form) return;

  const nombreInput = form.querySelector("input[name='nombre']");
  const telefonoInput = form.querySelector("input[name='telefono']");
  const emailInput = form.querySelector("input[name='email']");
  const checkbox = form.querySelector("input[name='privacidad']");
  const button = form.querySelector("button");
  const message = document.getElementById("muestra-form-message");

  const errors = {
    nombre: form.querySelector("[data-error='nombre']"),
    telefono: form.querySelector("[data-error='telefono']"),
    email: form.querySelector("[data-error='email']"),
  };

  const validateField = () => {
    let valid = true;

    if (nombreInput.value.trim() === "") {
      setFieldError(errors.nombre, "Ingresa tu nombre.");
      valid = false;
    } else {
      setFieldError(errors.nombre, "");
    }

    if (!isValidPhone(telefonoInput.value)) {
      setFieldError(
        errors.telefono,
        "Ingresa un teléfono válido de 10 dígitos."
      );
      valid = false;
    } else {
      setFieldError(errors.telefono, "");
    }

    if (!isValidEmail(emailInput.value)) {
      setFieldError(errors.email, "Ingresa un email válido.");
      valid = false;
    } else {
      setFieldError(errors.email, "");
    }

    if (!checkbox.checked) valid = false;

    button.disabled = !valid;
    return valid;
  };

  [nombreInput, telefonoInput, emailInput, checkbox].forEach((input) => {
    input.addEventListener("input", validateField);
    input.addEventListener("change", validateField);
  });

  form.addEventListener("submit", async (e) => {
  e.preventDefault();

  if (!validateField()) return;

  button.disabled = true;
  button.textContent = "Enviando...";

  let data;

  try {
    data = await submitCRMForm(form);
    console.log("CRM RESPUESTA:", data);
  } catch (error) {
    console.error("Error en el envío CRM:", error);

    showFormMessage(
      message,
      "Ocurrió un error al enviar el formulario.",
      false
    );

    button.disabled = false;
    button.textContent = "Enviar";
    return;
  }

  if (!data.success) {
    showFormMessage(
      message,
      "Ocurrió un error. Intenta más tarde.",
      false
    );

    button.disabled = false;
    button.textContent = "Enviar";
    return;
  }

  // El CRM confirmó el envío.
  console.log("CRM OK: redireccionando...");

  form.reset();

  window.location.href = "/thank-you/";
});
});

document.addEventListener("DOMContentLoaded", () => {
  // ---------------------------------
  // Formulario de contacto
  // ---------------------------------

  const form = document.getElementById("contacto-form");

  if (!form) return;

  const motivoButtons = document.querySelectorAll(
    ".contacto__form-tipo button"
  );

  const motivoInput = document.getElementById("motivo_contacto");

  const nombreInput = form.querySelector("input[name='nombre']");
  const emailInput = form.querySelector("input[name='email']");
  const telefonoInput = form.querySelector("input[name='telefono']");
  const ciudadInput = form.querySelector("input[name='ciudad']");
  const checkbox = form.querySelector("input[name='privacidad']");
  const button = form.querySelector("button");
  const message = document.getElementById("contacto-form-message");

  const errors = {
    nombre: form.querySelector("[data-error='nombre']"),
    email: form.querySelector("[data-error='email']"),
    telefono: form.querySelector("[data-error='telefono']"),
    ciudad: form.querySelector("[data-error='ciudad']"),
  };

  motivoButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      motivoButtons.forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      motivoInput.value = btn.dataset.motivo;
    });
  });

  const validateFields = () => {
    let valid = true;

    if (nombreInput.value.trim() === "") {
      setFieldError(errors.nombre, "Ingresa tu nombre.");
      valid = false;
    } else {
      setFieldError(errors.nombre, "");
    }

    if (!isValidEmail(emailInput.value)) {
      setFieldError(errors.email, "Ingresa un email válido.");
      valid = false;
    } else {
      setFieldError(errors.email, "");
    }

    if (!isValidPhone(telefonoInput.value)) {
      setFieldError(
        errors.telefono,
        "Ingresa un teléfono válido de 10 dígitos."
      );
      valid = false;
    } else {
      setFieldError(errors.telefono, "");
    }

    if (ciudadInput.value.trim() === "") {
      setFieldError(errors.ciudad, "Ingresa tu ciudad.");
      valid = false;
    } else {
      setFieldError(errors.ciudad, "");
    }

    if (!checkbox.checked) valid = false;

    button.disabled = !valid;
    return valid;
  };

  [nombreInput, emailInput, telefonoInput, ciudadInput, checkbox].forEach(
    (input) => {
      input.addEventListener("input", validateFields);
      input.addEventListener("change", validateFields);
    }
  );

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    if (!validateFields()) return;

    button.disabled = true;
    button.textContent = "Enviando...";

    try {
      const data = await submitCRMForm(form);

      if (data.success) {
        form.reset();

        motivoButtons.forEach((b) => b.classList.remove("is-active"));
        motivoButtons[0]?.classList.add("is-active");
        motivoInput.value = motivoButtons[0]?.dataset.motivo || "";

        button.disabled = true;

        showFormMessage(message, "¡Gracias por contactarnos!", true);
      } else {
        showFormMessage(
          message,
          "Ocurrió un error. Intenta más tarde.",
          false
        );

        button.disabled = false;
      }
    } catch (error) {
      console.error("Error CRM:", error);

      showFormMessage(
        message,
        "Ocurrió un error al enviar el formulario.",
        false
      );

      button.disabled = false;
    } finally {
      button.textContent = "Enviar";
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  // ---------------------------------
  // Formulario de distribuidores
  // ---------------------------------

  const form = document.getElementById("distribuidor-form");

  if (!form) return;

  const nombreInput = form.querySelector("input[name='nombre']");
  const emailInput = form.querySelector("input[name='email']");
  const telefonoInput = form.querySelector("input[name='telefono']");
  const ciudadInput = form.querySelector("input[name='ciudad']");
  const zonaInput = form.querySelector("input[name='zona_cdmx']");
  const checkbox = form.querySelector("input[name='privacidad']");
  const button = form.querySelector("button");
  const message = document.getElementById("distribuidor-form-message");

  const errors = {
    nombre: form.querySelector("[data-error='nombre']"),
    email: form.querySelector("[data-error='email']"),
    telefono: form.querySelector("[data-error='telefono']"),
    ciudad: form.querySelector("[data-error='ciudad']"),
  };

  const validateFields = () => {
    let valid = true;

    if (nombreInput.value.trim() === "") {
      setFieldError(errors.nombre, "Ingresa tu nombre.");
      valid = false;
    } else {
      setFieldError(errors.nombre, "");
    }

    if (!isValidEmail(emailInput.value)) {
      setFieldError(errors.email, "Ingresa un email válido.");
      valid = false;
    } else {
      setFieldError(errors.email, "");
    }

    if (!isValidPhone(telefonoInput.value)) {
      setFieldError(
        errors.telefono,
        "Ingresa un teléfono válido de 10 dígitos."
      );
      valid = false;
    } else {
      setFieldError(errors.telefono, "");
    }

    if (ciudadInput.value.trim() === "") {
      setFieldError(errors.ciudad, "Ingresa tu ciudad.");
      valid = false;
    } else {
      setFieldError(errors.ciudad, "");
    }

    if (!checkbox.checked) valid = false;

    button.disabled = !valid;
    return valid;
  };

  [nombreInput, emailInput, telefonoInput, ciudadInput, checkbox].forEach(
    (input) => {
      input.addEventListener("input", validateFields);
      input.addEventListener("change", validateFields);
    }
  );

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    if (!validateFields()) return;

    button.disabled = true;
    button.textContent = "Enviando...";

    try {
      const data = await submitCRMForm(form);

      if (data.success) {
        form.reset();
        zonaInput.value = "";
        button.disabled = true;

        showFormMessage(
          message,
          "¡Gracias! Te contactaremos pronto.",
          true
        );

        const popup = document.getElementById(
          "distribuidor-mapa-popup"
        );

        if (popup) {
          setTimeout(() => popup.classList.remove("is-visible"), 1000);
        }
      } else {
        showFormMessage(
          message,
          "Ocurrió un error. Intenta más tarde.",
          false
        );

        button.disabled = false;
      }
    } catch (error) {
      console.error("Error CRM:", error);

      showFormMessage(
        message,
        "Ocurrió un error al enviar el formulario.",
        false
      );

      button.disabled = false;
    } finally {
      button.textContent = "Enviar";
    }
  });
});